<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [(ngModel)]="idsRepresentantes"
  [variante]="variante"
  [icon]="icon"
  (isFirstOpened)="hasOpenedFirstTime($event)"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()">
  <ng-template #customOptionTemplate let-option>
    <span class="novo-representante-multi-select__opcao">
      <span
        class="novo-representante-multi-select__nome"
        [class.novo-representante-multi-select__nome--inativo]="idsInativos.has(option.id)">{{ option.label }}</span>
      <span *ngIf="idsInativos.has(option.id)" class="novo-representante-multi-select__inativo">Inativo</span>
    </span>
  </ng-template>
</sgt-multi-select>
